<template>
  <div>
    <vue-element-loading :active="isLoading" />
    <v-card class="pcard pcard--green">
      <div class="pcard-header">
        <div class="pcard-header-left">
          <div class="pcard-icon-wrap" style="background:rgba(255,255,255,0.18)">
            <v-icon color="white" size="22">mdi-credit-card-multiple-outline</v-icon>
          </div>
          <div>
            <p class="pcard-header-sub" style="color:rgba(255,255,255,0.9)!important">{{ $t('sidebar.payments') }}</p>
            <h2 class="pcard-header-title" style="color:#fff!important">{{ $t('pages.payments') }}</h2>
          </div>
        </div>
      </div>
      <div v-if="bankAccount || paymentDescription" style="background:#f0faf3; border-left:4px solid #2e7d32; margin:12px 16px 4px 16px; padding:10px 14px; border-radius:6px; display:flex; align-items:flex-start; gap:10px;">
        <v-icon color="#2e7d32" size="20" style="margin-top:2px; flex-shrink:0;">mdi-bank-outline</v-icon>
        <div style="flex:1; min-width:0;">
          <div style="font-size:11px; font-weight:600; color:#2e7d32; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:6px;">{{ $t('forms.payment_method') }}</div>
          <div v-if="bankAccount" style="font-size:15px; color:#1b5e20; font-weight:700; font-family:monospace; letter-spacing:0.5px; word-break:break-all; margin-bottom:4px;">{{ bankAccount }}</div>
          <div v-if="paymentDescription" style="font-size:12px; color:#388e3c; margin-top:2px;">{{ paymentDescription }}</div>
        </div>
      </div>
      <v-data-table
        :headers="headers"
        :items="payments"
        :options.sync="options"
        :server-items-length="totalPayments"
        class="elevation-1"
      >
        <template v-slot:top>
          <div class="d-flex flex-wrap align-center px-4 pt-3" style="gap: 12px">
            <v-select
              v-model="viti"
              :items="vitet"
              :label="$t('table.year')"
              outlined
              dense
              hide-details
              style="max-width: 140px"
            />
            <v-select
              v-model="muaji"
              :items="muajt"
              item-text="emri"
              item-value="nr"
              :label="$t('table.month')"
              outlined
              dense
              hide-details
              clearable
              style="max-width: 190px"
            />
          </div>
        </template>

        <template v-slot:item.student_name="{ item }">
          <v-avatar rounded size="38">
            <v-img :src="getStudentAvatarUrl(item)"></v-img>
          </v-avatar>
          {{ item.student_name }}
        </template>

        <template v-slot:item.created_by_name="{ item }">
          <v-avatar rounded size="38">
            <v-img :src="getUserAvatarUrl(item)"></v-img>
          </v-avatar>
          {{ item.created_by_name }}
        </template>

        <template v-slot:item.amount="{ item }"> € {{ item.amount }} </template>

        <template v-slot:item.created_at="{ item }">
          <small>{{ item.created_at | moment('DD/MM/YYYY') }}</small> -
          <small class="text-muted">
            {{ item.created_at | moment('HH:mm') }}
          </small>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading';
import CreateButton from '@/components/CreateButton.vue';
import { Keys } from '@/config';

export default {
  components: { CreateButton, VueElementLoading },
  data() {
    return {
      isLoading: false,
      bankAccount: null,
      paymentDescription: null,
      payments: [],
      search: '',
      viti: new Date().getFullYear(),
      muaji: null,
      headers: [
        { text: this.$t('table.student'), value: 'student_name' },
        { text: this.$t('table.created_by'), value: 'created_by_name' },
        { text: this.$t('table.amount'), value: 'amount' },
        { text: this.$t('table.months'), value: 'months' },
        { text: this.$t('table.created'), value: 'created_at' },
      ],
      options: {},
      totalPayments: 0,
    };
  },
  mounted() {
    this.loadBankAccount();
    this.loadPayments();
  },
  computed: {
    vitet() {
      const tani = new Date().getFullYear();
      // Pese vite prapa mjaftojne: me larg se kaq prindi nuk kerkon.
      return Array.from({ length: 6 }, (_, i) => tani - i);
    },

    muajt() {
      const gjuha = localStorage.getItem('locale') === 'en' ? 'en-GB' : 'sq-AL';
      return Array.from({ length: 12 }, (_, i) => ({
        nr: i + 1,
        emri: new Date(2000, i, 1).toLocaleDateString(gjuha, { month: 'long' }),
      }));
    },
  },

  methods: {
    loadBankAccount() {
      axios.get('/settings/bank-account')
        .then(r => { this.bankAccount = r.data.bank_account; this.paymentDescription = r.data.payment_description; })
        .catch(() => {});
    },
    loadPayments() {
      this.isLoading = true;
      const params = {
        page: this.options?.page,
        per_page: this.options?.itemsPerPage,
        order_by: this.options?.sortBy?.[0],
        order_direction:
          this.options?.sortDesc?.[0] === null ||
          this.options?.sortDesc?.[0] === undefined
            ? null
            : this.options?.sortDesc?.[0] === true
            ? 'DESC'
            : 'ASC',
        search: this.search,
        year: this.viti || null,
        month: this.muaji || null,
      };
      axios
        .get(`/school/payments/parent`, { params })
        .then((response) => {
          this.payments = response?.data?.data;
          this.totalPayments = response?.data?.total;
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error while retrieving payments',
            type: 'error',
          });
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    getStudentAvatarUrl(user) {
      if (user?.student_avatar) {
        return (this.avatarImageUrl =
          Keys.VUE_APP_API_URL + user?.student_avatar);
      } else {
        return (this.avatarImageUrl =
          Keys.VUE_APP_API_URL + '/storage/avatars/1/avatar.png');
      }
    },
    getUserAvatarUrl(user) {
      if (user?.created_by_avatar) {
        return (this.avatarImageUrl =
          Keys.VUE_APP_API_URL + user?.created_by_avatar);
      } else {
        return (this.avatarImageUrl =
          Keys.VUE_APP_API_URL + '/storage/avatars/1/avatar.png');
      }
    },
  },
  watch: {
    options: {
      handler(val) {
        this.loadPayments();
      },
      deep: true,
    },
    search: {
      handler(val) {
        this.loadPayments();
      },
      deep: true,
    },
    viti() {
      this.loadPayments();
    },
    muaji() {
      this.loadPayments();
    },
  },
};
</script>

<style scoped>
.pcard { border-radius: 14px !important; overflow: hidden; border: none !important; }
.pcard-header {
  padding: 18px 20px;
  display: flex; align-items: center; justify-content: space-between;
}
.pcard--green .pcard-header { background: linear-gradient(135deg, #2E7D32, #66BB6A); }
.pcard-header-left { display: flex; align-items: center; gap: 12px; }
.pcard-icon-wrap {
  width: 40px; height: 40px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
}
.pcard-header-sub {
  font-size: 11px; color: #fff !important;
  text-transform: uppercase; letter-spacing: 0.5px;
  margin: 0; font-weight: 600; opacity: 0.88;
}
.pcard-header-title { font-size: 18px; font-weight: 800; color: #fff !important; margin: 0; }
</style>
